export default __webpack_public_path__ + "static/media/03_chlopi.ce17ec1b.png";